
import { useState } from 'react';
import styled from "styled-components";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import HomeIcon from '@mui/icons-material/Home';
import EventIcon from '@mui/icons-material/Event';
import ImageIcon from '@mui/icons-material/Image';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import MailIcon from '@mui/icons-material/Mail';
import ForumIcon from '@mui/icons-material/Forum';
import GridViewIcon from '@mui/icons-material/GridView';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import ListAltIcon from '@mui/icons-material/ListAlt';
import GroupIcon from '@mui/icons-material/Group';


import { useLocation } from 'react-router-dom'
export default function LeftMenu({ menu, setMenu }) {
    const [open, setOpen] = useState(true);
    const location = useLocation();

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <List
            sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader component="h1" id="nested-list-subheader">
                    Walidata Menu
                </ListSubheader>
            }
        >

            <StyledListItemButton active={location?.pathname === "/"} component="a"  href="#/" >
                <ListItemIcon>
                    <HomeIcon color={location?.pathname === "/" ? 'primary' : ''} />
                </ListItemIcon>
                <ListItemText primary="Home" />
            </StyledListItemButton>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <GridViewIcon />
                </ListItemIcon>
                <ListItemText primary="Manage Metadata" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {
                        /*
                    <StyledListItemButton sx={{ pl: 4 }}  active={location?.pathname.includes("/data")? "true": undefined} component="a" href="#/data">
                        <ListItemIcon >
                            <MapIcon color={location?.pathname.includes("/data")? '005d2d' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Publish Spatial Data" />
                    </StyledListItemButton>
                    */
                    }
                    <StyledListItemButton sx={{ pl: 4 }} active={location?.pathname.includes("/metadata")? "true": undefined} component="a" href="#/metadata">
                        <ListItemIcon>
                            <CollectionsBookmarkIcon color={location?.pathname.includes("/metadata")? '005d2d' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Metadata List" />
                    </StyledListItemButton>
                </List>
            </Collapse>
            <StyledListItemButton active={location?.pathname.includes("/publication")? "true": undefined}  component="a"  href="#/publication" >
                <ListItemIcon>
                    <ListAltIcon color={location?.pathname.includes("/publication")? '005d2d' : ''}  />
                </ListItemIcon>
                <ListItemText primary="Publication List" />
            </StyledListItemButton>     
            
            <StyledListItemButton active={location?.pathname.includes("/keywords")} component="a" href="#/keywords">
                <ListItemIcon>
                    <LocalLibraryIcon color={location?.pathname.includes("/keywords") ? 'primary' : ''} />
                </ListItemIcon>
                <ListItemText primary="Keywords" />
            </StyledListItemButton>
            <StyledListItemButton active={location?.pathname.includes("/users")? "true": undefined}  component="a"  href="#/users" >
                <ListItemIcon>
                    <GroupIcon color={location?.pathname.includes("/users")? '005d2d' : ''}  />
                </ListItemIcon>
                <ListItemText primary="Users" />
            </StyledListItemButton>  
            <StyledListItemButton active={location?.pathname.includes("/activities")? "true": undefined}  component="a"  href="#/activities" >
                <ListItemIcon>
                    <ReceiptLongIcon color={location?.pathname.includes("/activities")? '005d2d' : ''}  />
                </ListItemIcon>
                <ListItemText primary="Activities" />
            </StyledListItemButton>       

            
        </List>
    )
    //primary={menu === 'home'}
}
const StyledListItemButton = styled(ListItemButton)`
    border-right: ${props => props.active ? "#1976d2 solid 5px !important" : ""};
    background-color: ${props => props.active ? "#eee!important" : "transparent"};
    color: ${props => props.active ? "#1976d2!important" : ""};
`;
/*
<StyledListItemButton active={location?.pathname.includes("/events") || location?.pathname.includes("newEvent")} component="a" href="#/events">
                <ListItemIcon>
                    <EventIcon color={location?.pathname.includes("/events")? 'primary' : ''} />
                </ListItemIcon>
                <ListItemText primary="Events" />
            </StyledListItemButton>
            <StyledListItemButton active={location?.pathname.includes("/gallery")} component="a" href="#/gallery">
                <ListItemIcon>
                    <ImageIcon color={location?.pathname.includes("/gallery")? 'primary' : ''} />
                </ListItemIcon>
                <ListItemText primary="Gallery" />
            </StyledListItemButton>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <GridViewIcon />
                </ListItemIcon>
                <ListItemText primary="Database" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    <StyledListItemButton sx={{ pl: 4 }}  active={location?.pathname.includes("/data")} component="a" href="#/data">
                        <ListItemIcon >
                            <MapIcon color={location?.pathname.includes("/data")? 'primary' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Data" />
                    </StyledListItemButton>
                    <StyledListItemButton sx={{ pl: 4 }} active={location?.pathname.includes("/services")} component="a" href="#/services">
                        <ListItemIcon>
                            <PublicIcon color={location?.pathname.includes("/services") ? 'primary' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Services" />
                    </StyledListItemButton>
                    <StyledListItemButton sx={{ pl: 4 }} active={location?.pathname.includes("/gazetteer")} component="a" href="#/gazetteer">
                        <ListItemIcon>
                            <CollectionsBookmarkIcon color={location?.pathname.includes("/gazetteer")? 'primary' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Gazetteer" />
                    </StyledListItemButton>
                    <StyledListItemButton sx={{ pl: 4 }} active={location?.pathname.includes("/genericterm")} component="a" href="#/genericterm">
                        <ListItemIcon>
                            <LocalLibraryIcon color={location?.pathname.includes("/genericterm") ? 'primary' : ''} />
                        </ListItemIcon>
                        <ListItemText primary="Generic Term" />
                    </StyledListItemButton>
                </List>
            </Collapse>
<StyledListItemButton active={location?.pathname.includes("/messages")} component="a" href="#/messages">
                <ListItemIcon>
                    <MailIcon color={location?.pathname.includes("/messages")? 'primary' : ''} />
                </ListItemIcon>
                <ListItemText primary="Messages" />
            </StyledListItemButton>
            */
/*background-color: ${props => props.active ? "#ccc!important" : "transparent"};*/
/*
   <Button>Normal</Button>
            <Button primary={true}>Primary</Button>
            <TomatoButton>Tomato Button</TomatoButton>
            <Button as={ReversedButton}>Custom Button with Normal Button styles</Button>
const Button = styled.button`
  /* Adapt the colors based on primary prop /
  background: ${props => props.primary ? "palevioletred" : "white"};
  color: ${props => props.primary ? "white" : "palevioletred"};

  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid palevioletred;
  border-radius: 3px;
`;

const TomatoButton = styled(Button)`
  color: tomato;
  border-color: tomato;
`;

const ReversedButton = props => <Button {...props} children={props.children.split('').reverse()} />
*/